export const TAX_PROVIDERS_RESET_STATE = 'TAX_PROVIDERS_RESET_STATE';
export const TAX_PROVIDERS_CURRENT_ITEM = 'TAX_PROVIDERS_CURRENT_ITEM';

export const TAX_PROVIDERS_REQUEST_LOADING = 'TAX_PROVIDERS_REQUEST_LOADING';
export const TAX_PROVIDERS_REQUEST_SUCCESS = 'TAX_PROVIDERS_REQUEST_SUCCESS';
export const TAX_PROVIDERS_REQUEST_FAILED = 'TAX_PROVIDERS_REQUEST_FAILED';

export const TAX_PROVIDERS_CURRENT_ACTION = 'TAX_PROVIDERS_CURRENT_ACTION';
export const TAX_PROVIDERS_RESET_ACTION = 'TAX_PROVIDERS_RESET_ACTION';